import {apiSlice} from './apiSlice';

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: (id) => 'user/?current=true',
      providesTags: ['Patient', 'User', 'Provider'],
    }),
  }),
});

export const {useGetCurrentUserQuery, useLazyGetCurrentUserQuery} = userApi;
